import axios from 'axios';
import { getDeviceId } from '../../utils/deviceId';

export function teamLoginContext(search = '') {
  const params = new URLSearchParams(search);
  // Keep even an empty/invalid explicit value, so the server rejects it instead of creating a default team.
  return params.has('team') ? { login_team_id: params.get('team') } : {};
}

export async function joinTeamWithCurrentSession(context) {
  const token = localStorage.getItem('token');
  const response = await axios.post('/api/auth/login/team', context, {
    timeout: 10000,
    headers: { Authorization: `Bearer ${token}`, 'X-Xiaoying-Device-ID': getDeviceId() },
  });
  return response.data;
}
